import ExcelJS from 'exceljs'
import {
  Status,
  headerRow,
  secondTitleColors,
  titleColors,
  toCamelCase,
} from 'modules/Roles/ViewRole/Header/Data.js'
import { DrivesButton } from 'modules/Roles/ViewRole/Style/style'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
const MyExportComponent = ({
  getRoleDataToExport,
  jobId,
  setLoadingRole,
  roleDataToExcel,
  roleName,
  disabled,
  filterDataForReport,
  sort,
  order,
}) => {
  const [data, setData] = useState([])
  const corporateData = useSelector(state => state?.auth?.corporateData)

  const statuses = filterDataForReport?.status
    ? Status(filterDataForReport?.status)
    : 'All'
  const titles = [
    { cellRange: 'A1:B1', title: 'Corporate Name' },
    { cellRange: 'C1:D1', title: corporateData?.name },
    {
      cellRange: 'E1:Q2',
      title:
        '                             ' +
        corporateData?.name +
        '  -  ' +
        statuses +
        ' Students Report',
    },
    { cellRange: 'A2:B2', title: 'Role Name' },
    { cellRange: 'C2:D2', title: roleName },

    { cellRange: 'A3:A3', title: '#' },
    { cellRange: 'B3:F3', title: 'Student Information' },
    { cellRange: 'G3:I3', title: 'Institute Information' },
    { cellRange: 'J3:L3', title: 'Educational Information' },
    { cellRange: 'M3:Q3', title: 'Marks (%)' },
  ]
  const exportToExcel = async (dynamicData, titles) => {
    const workbook = new ExcelJS.Workbook()
    const worksheet = workbook.addWorksheet('Candidate Report')

    const cellWidths = [
      6, 17, 25, 18, 16, 10, 35, 8, 8, 20, 20, 20, 7, 7, 10, 7, 7,
    ]
    worksheet.columns = cellWidths.map((width, index) => ({
      width,
      key: String.fromCharCode(65 + index), // A, B, C, ...
    }))
    let status = filterDataForReport?.status
      ? Status(filterDataForReport?.status)
      : 'All'

    titles.forEach((titleInfo, index) => {
      const { cellRange, title } = titleInfo
      worksheet.mergeCells(cellRange)
      const titleCell = worksheet.getCell(cellRange.split(':')[0])
      titleCell.value = title
      titleCell.font = {
        bold: !(
          titleCell.value == corporateData?.name ||
          titleCell.value == roleName ||
          titleCell.value == status
        ),
        size:
          titleCell.value ==
          '                             ' +
            corporateData?.name +
            '  -  ' +
            status +
            ' Students Report'
            ? 10.5
            : 11,
        color: {
          argb:
            titleCell.value == corporateData?.name ||
            titleCell.value == roleName ||
            titleCell.value == status
              ? '062b70'
              : titleCell.value == 'Corporate Name' ||
                titleCell.value == 'Role Name' ||
                titleCell.value == 'Status' ||
                titleCell.value ==
                  '                             ' +
                    corporateData?.name +
                    '  -  ' +
                    status +
                    ' Students Report'
              ? '002060'
              : 'FFFFFF',
        },
        name: 'Cambria',
      }
      titleCell.alignment = {
        horizontal:
          titleCell.value == corporateData?.name ||
          titleCell.value == roleName ||
          titleCell.value == status ||
          titleCell.value == 'Corporate Name' ||
          titleCell.value == 'Role Name' ||
          titleCell.value == 'Status' ||
          titleCell.value ==
            '                             ' +
              corporateData?.name +
              '  -  ' +
              status +
              ' Students Report'
            ? 'left'
            : 'center',
        vertical: 'middle',
        wrapText: true,
      }

      titleCell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: titleColors[index] },
      }

      titleCell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      }
    })

    const secondRow = worksheet.addRow(headerRow)

    secondRow.eachCell((cell, index) => {
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      }
      cell.font = {
        bold: false,
        size: 11,
        color: { argb: '002060' },
        name: 'Cambria',
      }
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: secondTitleColors[index] },
      }
      cell.alignment = {
        horizontal: 'center',
        vertical: 'middle',
        wrapText: true,
      }
    })

    dynamicData.forEach((item, index) => {
      const rowData = [
        index + 1,
        item.student?.firstName + ' ' + item.student?.lastName,
        item.student?.studentPersonalProfile?.primaryEmail
          ? item.student?.studentPersonalProfile?.primaryEmail
          : item.student?.studentPersonalProfile?.secondaryEmail,
        moment(parseInt(item?.student?.currentCourse?.startedOn)).format(
          'YYYY-MM'
        ) +
          ' to ' +
          moment(parseInt(item?.student?.currentCourse?.endedOn)).format(
            'YYYY-MM'
          ),
        item.student?.studentPersonalProfile?.phoneNumber,
        item?.student?.driveRoleCandidateMap?.[0]?.status
          ? Status(item?.student?.driveRoleCandidateMap?.[0]?.status)
          : 'Applied',
        item.student?.instituteCampusName ?? 'NA',
        item.student?.instituteInfo?.state ?? 'NA',
        item.student?.instituteInfo?.city ?? 'NA',
        item.student?.currentCourse?.shortForm
          ? item.student?.currentCourse?.shortForm +
            ' - ' +
            toCamelCase(item.student?.currentCourse?.degree)
          : toCamelCase(item.student?.currentCourse?.degree),

        item.student?.currentCourse?.department
          ? toCamelCase(item.student?.currentCourse?.department)
          : 'NA',
        item.student?.currentCourse?.educationLevel.toUpperCase(),
        item?.student?.educationProfile?.find(
          item => item?.educationLevel == 'tenth'
        )?.marks
          ? parseInt(
              item?.student?.educationProfile?.find(
                item => item?.educationLevel == 'tenth'
              )?.marks
            )?.toFixed(2)
          : item?.student?.currentCourse?.educationLevel == 'tenth'
          ? parseInt(item?.student?.currentCourse?.averageMarks)?.toFixed(2)
          : 'NA',
        item?.student?.educationProfile?.find(
          item => item?.educationLevel == 'twelfth'
        )?.marks
          ? parseInt(
              item?.student?.educationProfile?.find(
                item => item?.educationLevel == 'twelfth'
              )?.marks
            )?.toFixed(2)
          : item?.student?.currentCourse?.educationLevel == 'twelfth'
          ? parseInt(item?.student?.currentCourse?.averageMarks)?.toFixed(2)
          : 'NA',
        item?.student?.educationProfile?.find(
          item => item?.educationLevel == 'diploma'
        )?.marks
          ? parseInt(
              item?.student?.educationProfile?.find(
                item => item?.educationLevel == 'diploma'
              )?.marks
            )?.toFixed(2)
          : item?.student?.currentCourse?.educationLevel == 'diploma'
          ? item?.student?.currentCourse?.averageMarks
            ? parseInt(item?.student?.currentCourse?.averageMarks)?.toFixed(2)
            : 'NA'
          : 'NA',
        item?.student?.educationProfile?.find(
          item => item?.educationLevel == 'ug'
        )?.marks
          ? parseInt(
              item?.student?.educationProfile?.find(
                item => item?.educationLevel == 'ug'
              )?.marks
            )?.toFixed(2)
          : item?.student?.currentCourse?.educationLevel == 'ug'
          ? item?.student?.currentCourse?.averageMarks
            ? parseInt(item?.student?.currentCourse?.averageMarks)?.toFixed(2)
            : 'NA'
          : 'NA',
        item?.student?.educationProfile?.find(
          item => item?.educationLevel == 'pg'
        )?.marks
          ? parseInt(
              item?.student?.educationProfile?.find(
                item => item?.educationLevel == 'pg'
              )?.marks
            )?.toFixed(2)
          : item?.student?.currentCourse?.educationLevel == 'pg'
          ? item?.student?.currentCourse?.averageMarks
            ? parseInt(item?.student?.currentCourse?.averageMarks)?.toFixed(2)
            : 'NA'
          : 'NA',
      ]

      const dataRow = worksheet.addRow(rowData)

      dataRow.eachCell(cell => {
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        }
        cell.font = {
          size: 11,
          name: 'Cambria',
        }
        cell.alignment = {
          horizontal:
            isNaN(cell.value) && cell.value != 'NA' ? 'left' : 'center',
          vertical: isNaN(cell.value) && cell.value != 'NA' ? 'left' : 'center',
        }
      })
    })

    const buffer = await workbook.xlsx.writeBuffer()

    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    })

    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = roleName + ' candidate Report.xlsx'
    a.click()

    window.URL.revokeObjectURL(url)
  }
  const exportOnClick = e => {
    e.preventDefault()
    getRoleDataToExport(jobId, setLoadingRole, filterDataForReport, sort, order)
  }
  useEffect(() => {
    let data = roleDataToExcel?.result
    setData(data)
  }, [roleDataToExcel])
  useEffect(() => {
    if (data?.length > 0) {
      exportToExcel(data, titles)
    }
  }, [data])
  return (
    <div>
      <DrivesButton
        disabled={disabled}
        height="32px"
        text={'Export to Excel'}
        onClick={exportOnClick}
      />
    </div>
  )
}

export default MyExportComponent
